export default {
  metadata: {
    version: '1.0.0',
    id: 'pagination-button-1.0.0',
    name: 'JDSPaginationButton'
  },
  hierarchy: {
    container: [
      {
        'inner-container': ['jds-text']
      }
    ]
  },
  base: {
    container: {
      size: '{p_0}',
      'justify-content': '{p_1}',
      'align-items': '{p_2}',
      behavior: {
        hover: {},
        focus: {},
        active: {}
      }
    },
    'inner-container': {
      'background-color': '{p_3}',
      'flex-direction': '{p_4}',
      'justify-content': '{p_5}',
      'align-items': '{p_6}',
      'border-radius': '{p_7}',
      width: '{p_8}',
      height: '{p_9}',
      opacity: '{p_10}',
      gap: '{p_11}',
      'border-color': '{p_12}',
      behavior: {
        hover: {
          'background-color': '{p_13}'
        },
        active: {
          'background-color': '{p_14}'
        },
        focus: {
          'border-width': '{p_15}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_187}',
      color: '{text_15}',
      'font-size': '{text_186}',
      'line-height': '{text_188}',
      'letter-spacing': '{text_189}',
      'font-weight': '{text_190}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      behavior: {
        hover: {
          color: '{text_13}'
        },
        active: {
          color: '{text_13}'
        },
        focus: {
          color: '{text_13}'
        }
      }
    }
  },
  variant: {
    state: {
      selected: {
        'inner-container': {
          'background-color': '{p_16}'
        },
        'jds-text': {
          color: '{text_16}'
        }
      },
      ellipsis: {
        container: {
          disabled: true
        },
        'inner-container': {
          'background-color': '{p_17}'
        },
        'jds-text': {
          color: '{text_21}'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      state: {
        values: ['default', 'selected', 'ellipsis']
      }
    },
    data: {
      'jds-text': {
        value: {
          type: 'string',
          name: 'text'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick',
        onFocus: {
          name: 'onFocus',
          platform: 'web'
        },
        onBlur: {
          name: 'onBlur',
          platform: 'web'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'button'
          },
          'aria-current': '_ariaCurrent'
        }
      }
    }
  }
};
